import { IHocSinhAceChiTietLoadStart } from "../../../models/request/hoc-sinh/IHocSinhAceChiTietLoadStart";
import { IConCbnv, IConCbnvVm } from "../../../models/response/hoc-sinh/IConCbnv";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objConCbnvDefine = {
    LOAD_START: {} as IHocSinhAceChiTietLoadStart,
    LOAD_SUCCESS: [] as IConCbnvVm[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IConCbnv | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IConCbnv,
    SAVE_SUCESS: {} as IConCbnv,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eConCbnvActionTypeIds = generateActionTypeIds(objConCbnvDefine, "CON_CBNV")
export type IConCbnvActionTypes = IGenericActionType<typeof objConCbnvDefine, "CON_CBNV">
